// extracted by mini-css-extract-plugin
module.exports = {"Panel":"UploadPanel_Panel__J_G91","IconWrapper":"UploadPanel_IconWrapper__pz11M","Icon":"UploadPanel_Icon__KtGm5","Guide":"UploadPanel_Guide__p9cAe"};